import User from '../General/User';

export const enum ENTITY_TYPE {
  OTRO = 0,
  ENVIO = 1,
  RECEPCION = 2,
  ORDEN_DE_SERVICIO = 3,
  TICKET = 4,
}

export interface MessageChat {
  id?: number;
  date?: string;
  text: string;
  origin_user?: User | number;
  origin_user_data?: User;
  destination_users?: number[] | User[];
  destination_users_data?: User[];
  entity_type: ENTITY_TYPE;
  entity_id: number;
}
